import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, delay, put } from 'redux-saga/effects';
import { reduceEndorsementResult } from '../../actions/policy/reduceEndorsementResult';

// Keep the success toast on screen briefly before navigating to the new endorsement transaction.
const SUCCESS_REDIRECT_DELAY = 3000;

export function* createEndorsementSaga(action) {
    try {
        yield put(reduceLoading({ code: 'createEndorsement', value: true }));
        yield put(reduceEndorsementResult(null));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyEndorsement/create', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                sourceTransactionGuid: action.payload.sourceTransactionGuid,
                endorsementEffectiveDate: action.payload.endorsementEffectiveDate,
            }),
        });

        const result = yield call([response, 'json']);
        yield put(reduceEndorsementResult(result));
        yield put(reduceLoading({ code: 'createEndorsement', value: false }));

        if (result.operation?.status && result.policyTransaction?.guid) {
            yield put(
                addNotification({
                    code: 'createEndorsement',
                    type: 'success',
                    message: action.payload.successMessage,
                }),
            );
            yield delay(SUCCESS_REDIRECT_DELAY);
            // The endorsement is a new transaction with its own guid - navigate to it.
            window.location = `/profile?entity=${result.policyTransaction.guid}`;
        } else {
            // Surface backend validation errors via the notification center; modal stays open to retry.
            yield put(
                addNotification({
                    code: 'createEndorsement',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }
    } catch (error) {
        console.log('Error while creating Endorsement API - ', error);
        yield put(reduceEndorsementResult({ operation: { status: false } }));
        yield put(reduceLoading({ code: 'createEndorsement', value: false }));
        yield put(
            addNotification({
                code: 'createEndorsement',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
